import { Snack } from '@main/snackbar/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { SnackbarState, StateWithSnackbar } from '../snackbar-state';
import { getSnackbarFeatureState } from './feature.selector';

export const getSnackbar: MemoizedSelector<StateWithSnackbar, Snack[]> = createSelector(
  getSnackbarFeatureState,
  (state: SnackbarState) => state.snackbar,
);

export const getSnackbarHidden: MemoizedSelector<StateWithSnackbar, boolean> = createSelector(
  getSnackbarFeatureState,
  (state: SnackbarState) => state.hidden,
);
